import React, { Component } from 'react';

class ErrorPage extends Component{
	reload = () => {
    window.location.reload(true);
  };

	render() {
		return (
			<div className="main" >
				<div className="error-page" >
			    <p>Что то пошло не так</p>
			    <p>Обновите пожалуйста страницу</p>
			    <br />
			    <button className="flat_button" onClick={ this.reload }> Обновить страницу</button>
			    <br />
			    <br />
			    <a href="/" >Главная страница</a>
			  </div>
		  </div>
		)
	}
}

export default ErrorPage;


// WEBPACK FOOTER //
// ./src/components/ErrorPage/index.jsx